import * as React from "react";
import { Typography } from "antd";
import { IReport7ApplicantPresentationModel } from "../../../../presenter/report/model/Report7ApplicantPresentationModel";
import { TTranslate } from "../../../../service/locale/TranslationService";
import Report7PReviewNumericValuesGrid from "./Report7PreviewNumericValuesGrid";

const Report7PreviewApplicant = ({
  applicant,
  translate
}: {
  applicant: IReport7ApplicantPresentationModel;
  translate: TTranslate;
}) => {
  return (
    <div style={{ marginBottom: 20 }}>
      <Typography.Title style={{ fontSize: 20, marginBottom: 10 }}>
        {`${translate("report7_preview_applicant.name_and_surname")}: ${
          applicant.fullName
        }`}
      </Typography.Title>
      <Report7PReviewNumericValuesGrid
        translate={translate}
        applicant={applicant}
      />
    </div>
  );
};

export default Report7PreviewApplicant;
